import * as React from 'react';
import {
    CALCULATOR,
    CALCULATOR_MX,
    GLOBAL,
} from '../../../../constants/LabelConstants';
import {formatCurrency} from '../../../../utils/CurrencyUtils';
import {CalculatorSectionProps} from '../../../../types/mx/turboCash/components';
import {COUNTRY_INITIALS} from '../../../../../common/constants/AppConstants';
import {INPUTS} from '../../../../constants/MX/WizardInputs';
import * as InputTextTypes from '../../../../../common/components/InputTextTypes';
import InputText from '../../../../../common/components/InputText';

class CalculatorSectionView extends React.Component<CalculatorSectionProps, {}> {

    constructor(props) {
        super(props);
    }

    render() {
        const {
            firstNameField : {value: firstNameValue, error: firstNameError},
            secondNameField : {value: secondNameValue},
            lastNameField : {value: lastNameValue, error: lastNameError},
            secondLastNameField : {value: secondLastNameValue},
            priceField,
            downPaymentField,
            monthlyPaymentField,
            monthlyPayment,
            financingAmount,
            showErrors
        } = this.props;
        const completeName = `${firstNameValue} ${secondNameValue} ${lastNameValue} ${secondLastNameValue}`;
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={GLOBAL.APPLICANT_NAME}
                                   id={INPUTS.COMPLETE_NAME}
                                   value={completeName}
                                   hasError={showErrors}
                                   labelError={firstNameError || lastNameError}
                                   disabled/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={CALCULATOR_MX.VEHICLE_PRICE}
                                   id={INPUTS.VEHICLE_PRICE}
                                   value={formatCurrency(priceField.value, COUNTRY_INITIALS.MEXICO, '$', 0)}
                                   hasError={showErrors}
                                   labelError={priceField.error}
                                   disabled/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={CALCULATOR.ENTRY_MX}
                                   id={INPUTS.DOWN_PAYMENT}
                                   value={formatCurrency(
                                       downPaymentField.value, COUNTRY_INITIALS.MEXICO, '$', 0
                                   )}
                                   hasError={showErrors}
                                   labelError={downPaymentField.error}
                                   disabled/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={GLOBAL.TERM}
                                   id={INPUTS.TERM}
                                   value={`${monthlyPaymentField.value.value} ${GLOBAL.MONTHS}`}
                                   maxLength={10}
                                   minLength={10}
                                   hasError={showErrors}
                                   disabled
                                   onChange={e => console.log(e)}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={CALCULATOR_MX.MONTHLY_PAYMENTS}
                                   id={INPUTS.MONTHLY_PAYMENT}
                                   value={!!monthlyPayment && monthlyPayment.label &&
                                   monthlyPayment.label[monthlyPayment.label.length - 1]}
                                   hasError={showErrors}
                                   disabled/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={CALCULATOR_MX.FINANCING_AMOUNT}
                                   id={INPUTS.AMOUNT_FINANCE}
                                   value={financingAmount}
                                   hasError={showErrors}
                                   disabled/>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default CalculatorSectionView;